'use client';

import { useAppSelector } from '@lib/redux/store';
import { usePostHogIdentity } from '@ui/hooks';

/** Identifies the authenticated creator on every route mounted under the root Redux provider. */
export function CreatorPostHogIdentityBoundary() {
  const user = useAppSelector((state) => state.app.user);
  usePostHogIdentity({
    distinctId: user?.id,
    properties: { userType: 'creator', email: user?.email },
  });
  return null;
}
